/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { PutSaveDebtorCollectionItemMutationResponse, PutSaveDebtorCollectionItemPathParams, PutSaveDebtorCollectionItem401, PutSaveDebtorCollectionItem403 } from "../../models/PutSaveDebtorCollectionItem";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getPutSaveDebtorCollectionItemUrl({ debtorCode, collectionId, productCode }: { debtorCode: PutSaveDebtorCollectionItemPathParams["debtorCode"]; collectionId: PutSaveDebtorCollectionItemPathParams["collectionId"]; productCode: PutSaveDebtorCollectionItemPathParams["productCode"] }) {
  const res = { method: 'PUT', url: `/api/v1/debtors/${debtorCode}/collections/${collectionId}/products/${productCode}` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/collections/:collectionId/products/:productCode}
 */
export async function putSaveDebtorCollectionItem({ debtorCode, collectionId, productCode }: { debtorCode: PutSaveDebtorCollectionItemPathParams["debtorCode"]; collectionId: PutSaveDebtorCollectionItemPathParams["collectionId"]; productCode: PutSaveDebtorCollectionItemPathParams["productCode"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PutSaveDebtorCollectionItemMutationResponse, ResponseErrorConfig<PutSaveDebtorCollectionItem401 | PutSaveDebtorCollectionItem403>, unknown>({ method : "PUT", url : getPutSaveDebtorCollectionItemUrl({ debtorCode, collectionId, productCode }).url.toString(), ... requestConfig })  
  return res.data
}